import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import { Portuguese } from "flatpickr/dist/l10n/pt.js"

export default class extends Controller {
  static values = {
    enableTime: { type: Boolean, default: true },
    dateFormat: { type: String, default: "Y-m-d H:i" },
    altInput: { type: Boolean, default: true },
    altFormat: { type: String, default: "d/m/Y H:i" },
    time24hr: { type: Boolean, default: true }
  }

  connect() {
    this.fp = flatpickr(this.element, {
      enableTime: this.enableTimeValue,
      dateFormat: this.dateFormatValue,
      altInput: this.altInputValue,
      altFormat: this.altFormatValue,
      time_24hr: this.time24hrValue,
      locale: Portuguese,
      allowInput: true
    })
  }

  disconnect() {
    if (this.fp) {
      this.fp.destroy()
    }
  }
}
